import React, { useLayoutEffect } from 'react'

import DataSource from '@/containers/DataSource'

const DataSourcePage: React.FC = () => {
    return <DataSource />
}

export default DataSourcePage
